import { FeatureFlags as CatalogFeatureFlags } from '@tableau/catalog-core';
import { defaultMemoize } from 'reselect';

import { FeatureFlags as VizportalClientFeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

// This object is lazy-loaded because the feature flags aren't fully set up until after the app login
export const catalogFeatureFlagsAdapter = defaultMemoize((): CatalogFeatureFlags => {
  return {
    // Legacy Metrics content-type has been removed; this catalog flag is retired but the
    // external @tableau/catalog-core FeatureFlags interface still requires the field. Pass
    // false to preserve prior behavior (metricsDataCatalogEnabled was false on master).
    metricsDataCatalogEnabled: false,
    writableFieldDescriptionsEnabled: VizportalClientFeatureFlags.writableFieldDescriptionsEnabled,
    fieldDescriptionInheritanceLineageEnabled: VizportalClientFeatureFlags.fieldDescriptionInheritanceLineageEnabled,
    publishedConnectionsLineageEnabled: VizportalClientFeatureFlags.publishedConnectionsLineageEnabled,
    databasesInProjectsEnabled: VizportalClientFeatureFlags.databasesInProjectsEnabled,
    lensLineageEnabled: false,
    relevantAssetsEnabled: VizportalClientFeatureFlags.relevantAssetsEnabled,
    mixedContentConnectToDialogEnabled: VizportalClientFeatureFlags.mixedContentConnectToDialogEnabled,
    searchAndFilterOnLineagePageEnabled: VizportalClientFeatureFlags.searchAndFilterOnLineagePageEnabled,
    dataCloudInCatalogMVPEnabled: VizportalClientFeatureFlags.dataCloudInCatalogMVPEnabled,
    customLabelCategoriesEnabled: VizportalClientFeatureFlags.customLabelCategoriesEnabled,
    suggestDescriptionsEnabled: VizportalClientFeatureFlags.suggestDescriptionsEnabled,
    pulseInDataCatalogEnabled: VizportalClientFeatureFlags.pulseInDataCatalogEnabled,
  };
});
